export default __webpack_public_path__ + "static/media/cloudyrainbow.cbcb971c.png";